const initState = {
    type: '',
    name: null,
    path: null,
    hidden: false,
    error: null,
    total: null,
    progress: null,
}

const fileReducer = (state = initState, action) => {
    const type = action?.type;
    const name = action?.name;
    const path = action?.path;
    const error = action?.payload?.error;

    if (action.type.includes('FILE_UPLOAD')) {
        const total = action?.payload?.total;
        const progress = action?.payload?.progress;
        const hidden = action?.payload?.hidden;

        switch (action.type) {
            case 'FILE_UPLOAD_PENDING': return { ...state, type, name, path, progress, total, error: null, hidden: false }
            case 'FILE_UPLOAD_PROGRESS': return { ...state, type, name, path, progress, total, error: null }
            case 'FILE_UPLOAD_SUCCESS': return { ...state, type, name: null, path: null, progress, total, error: null, hidden: false }
            case 'FILE_UPLOAD_ERROR': return { ...state, type, progress, total, error, hidden: false }
            case 'FILE_UPLOAD_HIDDEN': return { ...state, hidden, name: null, path: null, error: null }

            default: return state;
        }
    }

    if (action.type.includes('FILE_DELETE')) {

        switch (action.type) {
            case 'FILE_DELETE_PENDING': return { ...state, type, error: null }
            case 'FILE_DELETE_SUCCESS': return { ...state, type, error: null }
            case 'FILE_DELETE_ERROR': return { ...state, type, error }

            default: return state;
        }
    }
    return state;

};

export default fileReducer;